/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import * as React from 'react';
import { Checkbox, TableCell, Theme } from '@mui/material';
import {
    DelayedDownloadingsListItemDto,
    DelayedDownloadingStatus,
} from '../../../data/api/downloadings/downloadingsClient.typings';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
    tableHeadCheckBoxCell: {
        borderBottomColor: theme.palette.text.primary,
        backgroundColor: theme.palette.mainBackground.light,
        color: theme.palette.text.secondary,
    },
}));

interface TableHeadCheckBoxProps {
    numSelected: number;
    onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    rowCount?: number;
}

export const TableHeadCheckBox = (props: TableHeadCheckBoxProps) => {
    const classes = useStyles();
    const { onSelectAllClick, numSelected, rowCount } = props;

    return (
        <TableCell className={classes.tableHeadCheckBoxCell} padding="checkbox">
            <Checkbox
                color="primary"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
            />
        </TableCell>
    );
};

interface RowCheckBoxProps {
    onSelect: (fileDto: DelayedDownloadingsListItemDto) => void;

    fileDto: DelayedDownloadingsListItemDto;
    selected: boolean;
}

export const RowCheckBox = (props: RowCheckBoxProps) => {
    const { onSelect, selected, fileDto } = props;

    return fileDto.status === DelayedDownloadingStatus.Ready || fileDto.status === DelayedDownloadingStatus.Error ? (
        <TableCell padding="checkbox">
            <Checkbox color="primary" onClick={() => onSelect(fileDto)} checked={selected} />
        </TableCell>
    ) : (
        <TableCell />
    );
};
